// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
//element
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import Cookies from "js-cookie";
import store from './store';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueClipboard from "vue-clipboard2";
import 'bootstrap/dist/css/bootstrap.css'
import {qxLink} from '@/utils/common.ts'
//公共跳转，，杰哥用这个
Vue.prototype.$link = qxLink

Vue.use(BootstrapVue)
Vue.use(ElementUI);
Vue.use(VueClipboard)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js